'use strict';

import { World } from '../World/World';
import { Slide } from '../Slider/Slide';
import gsap from 'gsap';

export class Viewer extends World {
  constructor (canvas,width,height,pixelRatio,params) {
    super(canvas,width,height,pixelRatio);

    this.params = params;
    this.slides = [];
  }

  loadSlides(dataArray) {
    const slides = [];

    dataArray.forEach(data => {
      const slide = new Slide(data,this.width,this.height,this.params).load();
      slides.push(slide);
    });

    Promise.all(slides).then(response => {
      this.slides = response;
      if (this.params.isOffscreen) {
        self.postMessage('launch');
      } else if (this.params.callbacks && this.params.callbacks.launch) {
        this.params.callbacks.launch();
      }
      this.run();
    });
  }

  run() {
    this.sliderTimeLine = gsap.timeline({paused: true, repeat: -1,
      onUpdate: () => {
        if (this.sliderTimeLine.time() > this.sliderTimeLine.duration() - this.params.fadeDuration) {
          this.sliderTimeLine.timeScale(15);
        } else {
          this.sliderTimeLine.timeScale(1);
        }
      },
      onRepeat: () => {
        if (this.params.isOffscreen) {
          self.postMessage('repeat');
        } else if (this.params.callbacks && this.params.callbacks.repeat) {
          this.params.callbacks.repeat();
        }
      }});

    this.slides.forEach((slide,index) => {
        slide.position = - index / 1000;
        this.addToScene(slide.slideGroup);
        slide.slideDirection = index % 2 === 0 ? -1 : 1;
        const slideTimeLineFirst = slide.play();
        this.sliderTimeLine.add(slideTimeLineFirst,this.params.slideDuration * index);
    });
    this.sliderTimeLine.play(0);
  }

  resize(width,height) {
    this.setSize(width,height);
    this.slides.forEach(slide => slide.resize(width,height));
  }

  dispose() {
    this.loop.stop();
    this.sliderTimeLine.kill();
    this.sliderTimeLine = null;
    this.slides.forEach(slide => slide.dispose());
    this.slides = null;
    this.renderer.dispose();
    this.scene = null;
    this.renderer = null;
    this.camera = null;
  }
}



